<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <!--CUSTOMER_DETAIL-->
      <div class="row mb-1" *ngIf="!!customer_id">
        <div class="col-12 d-flex justify-content-end">
          <a type="button" class="btn btn-primary" [routerLink]="'/dashboard/customer/edit/' + customer_id">{{ "EDIT" | translate }}</a>
        </div>
      </div>
      <div class="row" *ngIf="!!customer">
        <div class="col-lg-6 col-12">
          <div class="card">
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-12 mb-1" id="customer-profile">
                  <div id="logo">
                    <img
                      ngClass.sm="mb-075"
                      ngClass.md="mb-075"
                      #image
                      (load)="image.hidden = false"
                      (error)="image.hidden = true"
                      class="rounded contain"
                      [src]="customer.logo"
                      [alt]="'{{customer.name}}'"
                      width="100"
                      height="100"
                    />
                    <div ngClass.sm="mb-075" ngClass.md="mb-075" id="fake-avatar" class="rounded" *ngIf="image.hidden">
                      <span>{{ customer.name | initials }}</span>
                    </div>
                  </div>
                  <div>
                    <h3 class="mb-0">{{ customer.name }}</h3>
                    <p class="mb-0 font-small-3 text-muted">{{ customer.business_name }}</p>
                  </div>
                </div>
                <div class="col-12 mb-1">
                  <div class="row">
                    <div class="col mb-md-1" *ngIf="!!customer.vat_number">
                      <div class="font-weight-bold font-medium-1">{{ "VAT_NUMBER" | translate }}:</div>
                      <div>{{ customer.vat_number }}</div>
                    </div>
                    <div class="col mb-lg-1" *ngIf="!!customer.fiscalcode">
                      <div class="font-weight-bold font-medium-1">{{ "FISCAL_CODE" | translate }}:</div>
                      <div>{{ customer.fiscalcode }}</div>
                    </div>
                    <div class="col" *ngIf="!!customer.unique_code">
                      <div class="font-weight-bold font-medium-1">{{ "UNIQUE_CODE" | translate }}:</div>
                      <div>{{ customer.unique_code }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!customer.bank_name">
                  <div class="font-weight-bold font-medium-1">{{ "BANK" | translate }}:</div>
                  <div>{{ customer.bank_name }}</div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!customer.invoice_type_name">
                  <div class="font-weight-bold font-medium-1">{{ "INVOICE_TYPE" | translate }}:</div>
                  <div>{{ customer.invoice_type_name }}</div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!customer.pec">
                  <div class="font-weight-bold font-medium-1">{{ "PEC" | translate }}:</div>
                  <div>{{ customer.pec }}</div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!customer.recipient_pec">
                  <div class="font-weight-bold font-medium-1">{{ "RECIPIENT_PEC" | translate }}:</div>
                  <div>{{ customer.recipient_pec }}</div>
                </div>
                <div class="col-md-6 col-12 mb-2" *ngIf="!!customer.email">
                  <div class="font-weight-bold font-medium-1">{{ "EMAIL" | translate }}:</div>
                  <div>{{ customer.email }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="economicClient">
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-12 d-flex align-items-center justify-content-between">
                  <h3 class="mb-05">{{ "ECONOMIC_GRAPH" | translate }}</h3>
                  <label for="year" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
                    <select [(ngModel)]="selectedYearGraph" (ngModelChange)="loadCustomerGraph()" id="year" class="form-control pr-3 text-capitalize">
                      <option *ngFor="let year of availableYearsGraph" [value]="year" [label]="year">{{ year }}</option>
                    </select>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-12" id="chart" *ngIf="chartOptions && chartOptions.series && chartOptions.series.length > 0">
                  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [tooltip]="chartOptions.tooltip" [labels]="chartOptions.labels" [responsive]="chartOptions.responsive"></apx-chart>
                </div>
                <div class="col-12 pb-2" *ngIf="(chartOptions && chartOptions.series && chartOptions.series.length < 1) || !chartOptions.series">
                  {{ "NO_DATA_TO_COMPARE" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12" ngClass.sm="col-12" ngClass.md="col-12" *ngIf="(customer && customer.addresses && customer.addresses.length > 0) || (customer.referents && customer.referents.length > 0)">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 d-flex align-items-center">
                  <h3 class="mb-05"><i class="text-primary mr-05" data-feather="map" size="20"></i> {{ "MENU.CUSTOMERS_LOCATION" | translate }}</h3>
                </div>
              </div>
              <div class="row" *ngIf="customer && customer.addresses && customer.addresses.length > 0">
                <div class="col-12">
                  <ul class="list-unstyled mt-1 px-2 ml-075 font-medium-1">
                    <li *ngFor="let place of customer.addresses; let i = index" [class]="i < customer.addresses.length - 1 ? 'border-bottom pb-05 mb-05' : ''">
                      <strong>{{ place.label | titlecase }}</strong> <br />
                      <span>{{ place.street }} {{ place.zipcode }} {{ place.city_name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="customer && customer.referents && customer.referents.length > 0">
            <div class="card-body row">
              <div class="col-12 d-flex align-items-center">
                <h3 class="mb-05"><i class="text-info mr-05" data-feather="user" size="20"></i> {{ "MENU.CUSTOMERS_REFERENCE" | translate }}</h3>
              </div>
              <div class="col-12">
                <ul class="list-unstyled mt-1 px-2 ml-075 font-medium-1">
                  <li *ngFor="let referent of customer.referents; let i = index" [class]="i < customer.referents.length - 1 ? 'border-bottom pb-05 mb-05' : ''">
                    <strong>{{ referent.complete_name | titlecase }}</strong> <br />
                    <a class="mr-1" href="mailto:{{ referent.email }}" *ngIf="referent.email && referent.email.length > 0"> <i size="15" [data-feather]="'mail'"></i> {{ referent.email }} </a>
                    <a class="text-success" href="tel:{{ referent.phone }}" *ngIf="referent.phone && referent.phone.length > 0"> <i size="15" [data-feather]="'phone'"></i> {{ referent.phone }} </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--COMMISSIONS-->
      <div class="row" has_capability="show_menu_commission">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-0 pb-0">
              <div class="px-2 d-flex align-items-center">
                <h3 class="mb-0"><i class="text-primary mb-025" data-feather="briefcase" size="20"></i> {{ "MENU.COMMISSION" | translate }}</h3>
              </div>
              <div class="row p-2" *ngIf="!loadingCommissions">
                <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
                  <ng-select [(ngModel)]="filterStatusCommission" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="filterCommissions()">
                    <ng-option [value]="-1">
                      <span class="font-small-4 font-weight-normal pr-2">{{ "STATE" | translate }}</span>
                    </ng-option>
                    <ng-option [value]="0">
                      <span class="font-small-4 font-weight-normal pr-2">{{ "ACTIVE" | translate }}</span>
                    </ng-option>
                    <ng-option [value]="1">
                      <span class="font-small-4 font-weight-normal pr-2">{{ "CLOSE_MASCULIN" | translate }}</span>
                    </ng-option>
                  </ng-select>
                </div>
                <label for="years" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
                  <select id="years" [(ngModel)]="selectedYear" (change)="loadCustomerCommission()" class="form-control pr-3">
                    <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                  </select>
                </label>
              </div>
              <div class="col-12 my-1 py-2 border-top" *ngIf="loadingCommissions">{{ 'LOADING_COMMISSIONS' | translate }}</div>
              <ng-container *ngIf="!loadingCommissions">
                <ngx-datatable
                  class="bootstrap core-bootstrap"
                  columnMode="force"
                  [headerHeight]="30"
                  [scrollbarH]="true"
                  [rowHeight]="_utilService.isDesktop ? 90 : 230"
                  [limit]="tableLimit"
                  [footerHeight]="50"
                  [rows]="filteredCommissions"
                  [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
                  [sorts]="[{ prop: 'complete_name', dir: 'desc' }]"
                >
                  <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex" [ngSwitch]="row.record_type">
                        <a *ngSwitchDefault [routerLink]="'/dashboard/commission/edit/' + row.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.complete_name }}</a>
                        <a *ngSwitchCase="'product'" [routerLink]="'/dashboard/commissions/edit-product-commission/' + row.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.complete_name }}</a>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'STATE_ROUND' | translate" prop="status" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center">
                        <span class="badge badge-pill badge-light-success mr-1"
                              [ngClass]="{
                              'badge-light-success': !row.closed,
                              'badge-light-danger': row.closed
                              }">{{ (row.closed ? "CLOSE_MASCULIN" : "ACTIVE") | translate }}</span>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'START_DATE' | translate" prop="start_date" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.start_date | date: "dd/MM/yyyy" }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'END_DATE' | translate" prop="end_date" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span>{{ row.end_date | date: 'dd/MM/yyyy' }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'RESOURCES' | translate" [sortable]="false" width="80" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex">
                      <span *ngIf="!row.detachment && row.analytics && row.analytics.employees && row.analytics.employees.length === 1" [ngbTooltip]="row.analytics.employees ? formatTooltip(row.analytics.employees) : null">
                        <i [data-feather]="'user'" size="19"></i>
                      </span>
                        <span *ngIf="!row.detachment && row.analytics && row.analytics.employees && row.analytics.employees.length > 1" [ngbTooltip]="row.analytics.employees ? formatTooltip(row.analytics.employees) : null">
                        <i [data-feather]="'users'" size="19"></i>
                      </span>
                        <span *ngIf="row.detachment && row.analytics && row.analytics.employees && row.analytics.employees.length > 0" [ngbTooltip]="row.analytics.employees ? formatTooltip(row.analytics.employees) : null">
                        <i [data-feather]="'repeat'" size="19"></i>
                      </span>
                        <span *ngIf="row.analytics && row.analytics.products && row.analytics.products.length > 0" [ngbTooltip]="row.analytics.products ? formatTooltip(row.analytics.products) : null">
                        <i [data-feather]="'package'" size="19"></i>
                      </span>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'TOTAL_COSTS' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center">{{ row.analytics.real_cost | currency: 'EUR' }}</div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'TOTAL_REVENUE' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center">{{ row.analytics.real_profit | currency: 'EUR' }}</div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'EURO_MARGIN' | translate" prop="margin_currency" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center" *ngIf="row.analytics.real_profit && row.analytics.real_cost">{{ (row.analytics.real_profit - row.analytics.real_cost) | currency: 'EUR'}} €</div>
                      <div class="d-flex align-items-center" *ngIf="!row.analytics.real_profit || !row.analytics.real_cost">{{ 0 | currency: 'EUR'}} €</div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column [name]="'PERCENTAGE_MARGIN' | translate" prop="margin_percentage" *ngIf="_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="d-flex align-items-center">{{ _utilService.calculatePercentageBetweenTwoNumbers(row.analytics.real_profit,row.analytics.real_cost) }} %</div>
                    </ng-template>
                  </ngx-datatable-column>
                  <!--mobile - tablet-->
                  <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <div class="col-12 list-item-mobile pl-0">
                        <div [ngSwitch]="row.record_type">
                          <a *ngSwitchDefault [routerLink]="'/dashboard/commission/edit/' + row.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.complete_name }}</a>
                          <a *ngSwitchCase="'product'" [routerLink]="'/dashboard/commissions/edit-product-commission/' + row.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.complete_name }}</a>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "STATE" | translate }}: </span>
                          <span>{{ row.status === 0 ? ("ACTIVE" | translate) : ("DEACTIVATE" | translate) }}</span>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "START_DATE" | translate }}: </span>
                          <span>{{ _utilService.formatDate(row.start_date) }}</span>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "END_DATE" | translate }}: </span>
                          <span>{{ _utilService.formatDate(row.end_date) }}</span>
                        </div>
                        <div class="d-flex">
                          <span class="font-weight-bold mr-075">{{ "PRODUCTS" | translate }}: </span>
                          <div class="d-flex">
                          <span
                            *ngIf="!row.detachment && row.analytics && row.analytics.employees && row.analytics.employees.length === 1"
                            [ngbTooltip]="row.analytics.employees ? formatTooltip(row.analytics.employees) : null"
                          >
                            <i [data-feather]="'user'" size="19"></i>
                          </span>
                            <span
                              *ngIf="!row.detachment && row.analytics && row.analytics.employees && row.analytics.employees.length > 1"
                              [ngbTooltip]="row.analytics.employees ? formatTooltip(row.analytics.employees) : null"
                            >
                            <i [data-feather]="'users'" size="19"></i>
                          </span>
                            <span
                              *ngIf="row.detachment && row.analytics && row.analytics.employees && row.analytics.employees.length > 0"
                              [ngbTooltip]="row.analytics.employees ? formatTooltip(row.analytics.employees) : null"
                            >
                            <i [data-feather]="'repeat'" size="19"></i>
                          </span>
                            <span
                              *ngIf="row.analytics && row.analytics.products && row.analytics.products.length > 0"
                              [ngbTooltip]="row.analytics.products ? formatTooltip(row.analytics.products) : null"
                            >
                            <i [data-feather]="'package'" size="19"></i>
                          </span>
                          </div>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "TOTAL_COSTS" | translate }}: </span>
                          <span>{{ row.analytics.real_cost | currency: 'EUR' }} €</span>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "TOTAL_REVENUE" | translate }}: </span>
                          <span>{{ row.analytics.real_profit | currency: 'EUR' }} €</span>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "EURO_MARGIN" | translate }}: </span>
                          <span *ngIf="row.analytics.real_profit && row.analytics.real_cost ">{{ (row.analytics.real_profit - row.analytics.real_cost) | currency: 'EUR' }}</span>
                        </div>
                        <div>
                          <span class="font-weight-bold">{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                          <span>{{ row.analytics.margin_percentage }} %</span>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
                <div class="p-1">{{ "TOTAL_COSTS" | translate }}: {{ totalCost | currency: 'EUR' }}</div>
                <div class="px-1 pb-1">{{ "TOTAL_REVENUE" | translate }}: {{ totalRevenue | currency: 'EUR' }}</div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
